import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ModalDialog } from '@kanos/ui';
/**
 * Asks before input that is not saved yet is lost - closing a form, or a way out of the page.
 * Escape and a click outside keep editing: losing input takes a deliberate press.
 */
export function DiscardDialog({ onKeep, onDiscard, }) {
    return (_jsx(ModalDialog, { title: "\u00C4nderungen verwerfen?", description: "Was Sie eingegeben haben, ist noch nicht gespeichert.", isOpen: true, onOpenChange: (open) => {
            if (!open)
                onKeep();
        }, children: (close) => (_jsxs("div", { className: "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", children: [_jsx(Button, { variant: "quiet", onPress: close, children: "Weiter bearbeiten" }), _jsx(Button, { variant: "danger", onPress: onDiscard, children: "Verwerfen" })] })) }));
}
//# sourceMappingURL=discard-dialog.js.map